import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FileManagementService {

  constructor(private http: HttpClient) { }

  getAPIs(api) {
    return this.http.get(api);
  }

}
